// extracted by mini-css-extract-plugin
export var oSolution = "solution-module--o-solution--LJVuP";
export var oSolution__message = "solution-module--o-solution__message--3vbQF";
export var visible = "solution-module--visible--3FYgI";
export var lContent__inner = "solution-module--l-content__inner--1RSrj";
export var standby = "solution-module--standby--1sG-M";